import {currentUser} from './client'

/* «Я в древе» — какой персоне соответствует вошедший.
 *
 * В Gramps Web такой связи нет: в таблице users только логин, почта, роль
 * и дерево — привязки к персоне не предусмотрено. Поэтому держим её у себя,
 * рядом с логином: у каждого родственника свой аккаунт и свой «я», а древо
 * при входе открывается от него, а не от случайного человека.
 */

const key = () => `ft.me.${currentUser() || 'anon'}`

export const myHandle = (): string | null => localStorage.getItem(key())

export function setMyHandle(handle: string | null): void {
  if (handle) localStorage.setItem(key(), handle)
  else localStorage.removeItem(key())
}
